import { render } from "./MakeAdmin.vue?vue&type=template&id=7d66c8a4"
import script from "./MakeAdmin.vue?vue&type=script&lang=js"
export * from "./MakeAdmin.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\surface\\3D Objects\\Work\\schools\\inspire-school\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__